/**
 * Format phone number to Swiss international standard
 * Swiss format: +41 XX XXX XX XX
 */
export function formatSwissPhone(phone) {
  if (!phone) return '';
  
  // Remove all non-digit characters except +
  let cleaned = phone.replace(/[^\d+]/g, '');
  
  // If starts with 00, replace with +
  if (cleaned.startsWith('00')) {
    cleaned = '+' + cleaned.substring(2);
  }
  
  // Convert local format (0XX) to international (+41 XX)
  if (cleaned.startsWith('0') && !cleaned.startsWith('00')) {
    cleaned = '+41' + cleaned.substring(1);
  }
  
  // If starts with 41 (without +), add +
  if (cleaned.startsWith('41') && !cleaned.startsWith('+')) {
    cleaned = '+' + cleaned;
  }
  
  // If no country code, assume Swiss
  if (!cleaned.startsWith('+') && cleaned.length === 9) {
    cleaned = '+41' + cleaned;
  }
  
  // Format Swiss numbers (+41 XX XXX XX XX)
  if (cleaned.startsWith('+41') && cleaned.length === 12) {
    return `+41 ${cleaned.substring(3, 5)} ${cleaned.substring(5, 8)} ${cleaned.substring(8, 10)} ${cleaned.substring(10, 12)}`;
  }
  
  // For numbers that are close but not exact length
  if (cleaned.startsWith('+41') && cleaned.length >= 11) {
    const rest = cleaned.substring(3);
    if (rest.length >= 9) {
      return `+41 ${rest.substring(0, 2)} ${rest.substring(2, 5)} ${rest.substring(5, 7)} ${rest.substring(7, 9)}`;
    }
  }
  
  // Return with + prefix if it has one
  if (cleaned.startsWith('+')) {
    return cleaned;
  }
  
  return phone; // Return original if can't format
}

/**
 * Get tel: link from phone number
 */
export function getPhoneLink(phone) {
  if (!phone) return '';
  // Remove all non-digit characters except +
  const cleaned = phone.replace(/[^\d+]/g, '');
  return `tel:${cleaned}`;
}

/**
 * Check if a field name is a phone field
 */
export function isPhoneField(fieldName) {
  const lower = fieldName.toLowerCase();
  return lower.includes('tel') || 
         lower.includes('phone') || 
         lower.includes('mobile') || 
         lower.includes('handy') || 
         lower.includes('fax') ||
         lower.includes('natel');
}

/**
 * Check if a field name is an email field
 */
export function isEmailField(fieldName) {
  const lower = fieldName.toLowerCase();
  return lower.includes('mail') || lower.includes('e-mail');
}
